module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (108).a0f57754.jpg";